@switch (status) {
  @case ('LOADING') {
    <div class="mt-1 text-body-secondary">
      <em>Loading Groups&hellip;</em>
    </div>
  }

  @case ('ERRORED') {
    <div class="mt-1 text-danger">Failed to get Groups</div>
    <button type="button" class="btn btn-outline" (click)="fetchGroups()">
      Retry?
    </button>
  }

  @case ('OK') {
    <select
      class="form-select"
      [class.is-invalid]="showError"
      [style.border-bottom-left-radius]="group?.description ? 0 : null"
      [style.border-bottom-right-radius]="group?.description ? 0 : null"
      [(ngModel)]="model"
      [disabled]="disabled"
      (ngModelChange)="onChange($event)"
      (blur)="onTouched()"
    >
      <option [ngValue]="null">Select&hellip;</option>
      @for (group of assetGroups; track group) {
        <option
          [ngValue]="group.assetGroupId"
          [disabled]="group.assetGroupId === currentGroupId"
        >
          @if (group.parentGroup) {
            {{ group.parentGroup }} >
          }
          {{ group.name }}
        </option>
      }
    </select>
    @if (group?.description; as groupDescription) {
      <div
        class="border border-top-0 rounded-bottom p-2 ps-3 pe-3 text-sm text-body-secondary"
      >
        {{ groupDescription }}
      </div>
    }
    <ng-content></ng-content>
  }
}

@if (canAddNewGroup) {
  <div class="w-100">
    <button
      type="button"
      (click)="onCreateAssetGroup()"
      class="btn btn-link ps-0"
    >
      <i-lucide name="plus"></i-lucide>
      Add New Group
    </button>
  </div>
}

<app-side-panel #sidePanel></app-side-panel>
